import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { IconBuilding } from '../components/Icons';

const IconPause = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>);
const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));
const LUC = {
  GRIGIO: { c: '#9ca3af', l: 'Libera (aggredibile)' },
  VERDE: { c: '#22c55e', l: 'Cliente TIM' },
  NERO: { c: '#111827', l: 'Presidiata' },
  VIOLA: { c: '#a855f7', l: 'Presidio condizionato' },
  ROSSO: { c: '#ef4444', l: 'Rosso' },
  GIALLO: { c: '#eab308', l: 'Giallo' },
  ARANCIONE: { c: '#f97316', l: 'Arancione' },
  'NON TROVATO': { c: '#94a3b8', l: 'Non trovata' },
};
const ORDER = ['GRIGIO', 'ROSSO', 'GIALLO', 'ARANCIONE', 'VERDE', 'VIOLA', 'NERO', 'NON TROVATO'];

export default function SsmatePage() {
  const [d, setD] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/ssmate/dashboard`).then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 12000); return () => clearInterval(t); }, [load]);

  if (!d) return <div className="m-empty">Caricamento…</div>;

  const v = d.verifiche || {};
  const pct = v.con_cf ? Math.round((100 * v.verificati) / v.con_cf) : 0;
  const luc = d.lucchetti || {};
  const totLuc = Object.values(luc).reduce((a, b) => a + b, 0);
  const job = d.agente?.job;

  return (
    <>
      <div className={`m-verdict ${d.agente?.attivo ? '' : 'warn'}`}>
        <span className="vi">{d.agente?.attivo ? <IconBuilding size={16} /> : <IconPause size={16} />}</span>
        <div>
          <div className="vt">{d.agente?.attivo ? (job ? 'AI in verifica' : 'AI in attesa') : 'AI SSMATE fermo'}</div>
          <div className="vs">{job ? `${nf(job.completed)}/${nf(job.total)} · ${job.current || ''}` : `${nf(v.verificabili)} da verificare`}</div>
        </div>
      </div>

      <div className="m-secrow"><h2>Verifiche</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(v.con_cf)}</div><div className="cl">Con CF</div></div>
        <div className="m-chip k-tim"><div className="cn">{nf(v.verificati)}</div><div className="cl">Verificate {pct}%</div></div>
        <div className="m-chip k-non"><div className="cn">{nf(v.verificabili)}</div><div className="cl">Da fare</div></div>
        <div className="m-chip k-cop"><div className="cn">{nf(v.lavorabili)}</div><div className="cl">Lavorabili</div></div>
      </div>

      <div className="m-secrow"><h2>Esiti — lucchetti</h2></div>
      {totLuc === 0 ? (
        <div className="m-empty">Nessuna verifica ancora.</div>
      ) : (
        ORDER.filter((k) => luc[k]).map((k) => {
          const meta = LUC[k] || { c: '#94a3b8', l: k };
          const p = Math.round((100 * luc[k]) / totLuc);
          return (
            <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 2px' }}>
              <span style={{ width: 12, height: 12, borderRadius: '50%', background: meta.c, flex: '0 0 auto' }} />
              <span style={{ flex: 1, fontSize: 13, color: 'var(--fg)' }}>{meta.l}</span>
              <div style={{ flex: '0 0 70px', height: 6, background: 'var(--line, rgba(255,255,255,.12))', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${p}%`, height: '100%', background: meta.c }} />
              </div>
              <span style={{ flex: '0 0 54px', textAlign: 'right', fontSize: 13, fontWeight: 700 }}>{nf(luc[k])}</span>
            </div>
          );
        })
      )}

      <div className="m-secrow"><h2>Utenti & attività</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(d.utenti?.disponibili)}</div><div className="cl">Utenti ok</div></div>
        <div className="m-chip"><div className="cn">{nf(d.utenti?.esauriti?.length || 0)}</div><div className="cl">Esauriti</div></div>
        <div className="m-chip"><div className="cn">{nf(d.uso?.oggi)}</div><div className="cl">Oggi</div></div>
        <div className="m-chip"><div className="cn">{nf(d.uso?.totale)}</div><div className="cl">Totale</div></div>
      </div>
      {d.utenti?.esauriti?.length > 0 && (
        <div className="m-sub" style={{ marginTop: 4 }}>Esauriti oggi: {d.utenti.esauriti.join(', ')}.</div>
      )}
    </>
  );
}
